export default "https://assets.pclncdn.com/web/next-landing/8f5502c/_next/static/images/hotel-image-tablet-2x-bbc460b6a651e02c2fa848e188984b59.jpg";